<div *ngIf="showSpinner" class=" absolute opacity w-full h-full z-99 ">
    <k-spinner class="absolute w-fit h-fit left-1/2 top-1/2  "
        style="margin-left: -75px; margin-top: -75px; "></k-spinner>
</div>
<router-outlet></router-outlet>
<p-toast key="toast" position="bottom-center"></p-toast>